import PrenatalCareApp from './components/PrenatalCareApp';

function App() {
  return <PrenatalCareApp />;
}

export default App;
